import { render, staticRenderFns } from "./SfxView.vue?vue&type=template&id=0d7ce493&scoped=true"
import script from "./SfxView.vue?vue&type=script&lang=js"
export * from "./SfxView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d7ce493",
  null
  
)

export default component.exports